import { User } from "../store/config";
import * as api from "./api";

interface ApiResponse {
  status: number;
  message: string;
  data: User[];
  meta: {
    totalItems: number;
    totalFreeUsers: number;
    totalPaidUsers: number;
    totalAllUsers: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

const getAuthToken = () => {
  return localStorage.getItem("token") || "{}";
};
// fetch user list
export const fetchUserList = async (data: {
  userType: string;
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params = {
    userType: data.userType,
    page: data.page,
    limit: data.limit,
  };
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get("/user", params);
  return response;
};

// block unblock user
export const blockUser = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.get(`/user/${id}`);
};
